import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TSplitItemTableRow } from './types';
import { EIconButtons } from '../../../../ui/EasTable/EasTableRow/EasTableValue/constants';
import { COLORS } from '../../../../services/constants/colors';

export const splitItemTableStructure: TTableStructure<
	keyof TSplitItemTableRow,
	TSplitItemTableRow
>[] = [
	{
		selector: 'type_of_goods',
		name: 'Product Type',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.ICON,
		icons: [
			{
				value: 'TBE',
				icon: EIconButtons.CLOUD_DOWNLOAD,
			},
			{
				value: 'Goods',
				icon: EIconButtons.LOCAL_SHIPPING,
			},
		],
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		value: (item) => (item.type_of_goods === 'GOODS' ? 'Goods' : 'TBE'),
		tooltip: (item) => (item.type_of_goods === 'GOODS' ? 'Goods' : 'TBE'),
	},

	{
		selector: 'id',
		name: 'ID',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		key: true,
	},
	{
		selector: 'id_provided_by_em',
		name: 'Item ID',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'short_description',
		name: 'Product Name',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 2,
	},
	{
		selector: 'hs6p_received',
		name: 'HS6+ Received',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'hs6p_applicable',
		name: 'HS6+ Applicable',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'fulfillment_country',
		name: 'Fulfillment Country',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.COUNTRY_CODE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		selector: 'location_warehouse_country',
		name: 'Warehouse Country',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.COUNTRY_CODE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		selector: 'originating_country',
		name: 'Originating Country',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.COUNTRY_CODE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		selector: 'weight_in_kg',
		name: 'Item Weight',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: (item) => 'kg',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'quantity',
		name: 'Quantity',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},

	{
		selector: 'cost_provided_by_em_inclusive_vat',
		name: 'Item Price inc. VAT',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'cost_provided_by_em',
		name: 'Item Price',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'prorated_delivery_cost',
		name: 'Delivery part',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'merchandise_cost',
		name: 'Merch Amount',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'vat_rate',
		name: 'VAT Rate',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: (item) => '%',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'vat_value',
		name: 'Item VAT',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		value: (item) => String(item.vat_value - item.item_delivery_charge_vat),
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'item_delivery_charge_vat',
		name: 'Delivery VAT',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'import_duty_rate',
		name: 'Duties Rate',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: (item) => item.import_duty_rate_unit ?? '%',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'reduced_tbe_vat_group',
		name: 'TBE Reduced VAT',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		selector: 'import_duty_value',
		name: 'Import Duty',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'merchandise_cost',
		name: 'Total',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		sxTableCell: { fontWeight: '900', color: COLORS.PRIMARY },
		colSpan: 1,
		value: (item) => String(item.import_duty_value + item.vat_value + item.merchandise_cost),
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'weight',
		name: 'Item Weight (EM)',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'act_as_disclosed_agent',
		name: 'Disclosed Agent',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		selector: 'seller_registration_country',
		name: 'Country of Underline Seller',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.COUNTRY_NAME,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
];
